import { render, staticRenderFns } from "./CourseBasicCertifiedItem.vue?vue&type=template&id=43ee0162"
import script from "./CourseBasicCertifiedItem.vue?vue&type=script&lang=js"
export * from "./CourseBasicCertifiedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports